import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getVSaldByAfid,setofUpdatedashboard} from 'actions'
import {isEmpty, isUndefined} from 'lodash'
import BackGroupChart from './BackGroupChart'
import {Grid} from '@material-ui/core'
import { sv } from "date-fns/locale";
import {format}  from 'date-fns';
import moment from 'moment';
import {NumberFormat} from 'components/NotyNumberFormat'
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboard,DashBoardValueOf} = accountsData;
    const { VunnAffarSal,SenasteVunnenV,DashboardSaljFilterOption,VunnAffarSal2, UtfallSdiagram} = DashBoard;
    return {
        authUser,VunnAffarSal,SenasteVunnenV,DashboardSaljFilterOption,VunnAffarSal2, UtfallSdiagram,
        updatedashboard,DashBoardValueOf
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getVSaldByAfid: (Afid,userid,FilterOption) => dispatch(getVSaldByAfid(Afid,userid,FilterOption)),
        setofUpdatedashboard: () => dispatch(setofUpdatedashboard()),
        dispatch
    };
}

class TopList extends Component {
    state={
        VunnAffarAntalSal:0,
        DashboardSaljFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getVSaldByAfid(Afid,undefined,this.state.DashboardSaljFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })          
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({ done: false })
                    const Afid = this.props.Afid;
                    this.props.getVSaldByAfid(Afid,undefined,this.state.DashboardSaljFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            180000
        );
      }
    componentDidUpdate=()=>{
        const Afid = this.props.Afid;
        if(parseInt(this.props.updatedashboard) === 1){
            this.props.getVSaldByAfid(Afid,undefined,this.state.DashboardSaljFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) 
            this.props.setofUpdatedashboard()
        }
        if(this.props.DashboardSaljFilterOption !== this.state.DashboardSaljFilterOption && !isEmpty(this.props.DashboardSaljFilterOption))
           {  
               this.props.getVSaldByAfid(Afid,undefined,this.state.DashboardSaljFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
               this.setState({
                   DashboardSaljFilterOption:this.props.DashboardSaljFilterOption 
               }) 
           }
       }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    getDashBoardValueOf = ()=>{
        try{
        let ModuleValue = JSON.parse(this.props.DashBoardValueOf).find(item=>parseInt(item.DashBaord) === 3)
        if(ModuleValue.Value > 2 && ModuleValue.Value !== 5){
            return 2
        }else{
            return 1
        }
    }
    catch(error){return 1}
    }
    formatNumber=(number)=>{
			const _ValueOF = this.getDashBoardValueOf()
      let Nubmer =  NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
			let suffix = Nubmer.match(/[a-zA-Z]+/g)
			let num = Nubmer.replace(suffix, '').trim()
			let fontSize = 100

			// if(String(num).length > 5) fontSize = 60
			// if(String(num).length > 7) fontSize = 40

			return <div>
            <span style={{ fontSize: this.props.isFrom === 1 ? 55 : fontSize }}>{num}</span>
            <span style={{ fontSize: '2rem', marginLeft: 5 }}>{this.formatNumberT(number)}</span> 
      </div>
   	}
		formatNumberT=(number)=>{
        try{
						const _ValueOF = this.getDashBoardValueOf()
            let Nubmer =NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
            let num = Nubmer.match(/[a-zA-Z]+/g)
            return num
        }
        catch(error){
            return ''
        }
    }		
    formatNumber1=(number)=>{
      const _ValueOF = this.getDashBoardValueOf()
      return NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
    }
    render() {
        return (
            <>
            <div className="jr-card jr-card-full m-0"
            style={{ backgroundColor: 'transparent' }}
            >
            <div
                   className={
                       `jr-fillchart jr-overlay-fillchart`
                   }
                   style={{ backgroundColor: 'transparent' }}
               >  
            <BackGroupChart height={this.props.height}/>
            </div>
           
            <div className="jr-fillchart-content">
            <div className="text-center text-white">
               <h2 style={{ paddingTop: this.props.isFrom === 1 ? '0' : '6px', margin: '0', fontWeight: '500',fontSize: this.props.isFrom === 1 ? '20px' : '24px' }}><IntlMessages id="DashBoard.Deals.Value"/></h2>
               <p style={{ textTransform: "capitalize", fontSize: this.props.isFrom === 1 ? 14 : '18px' }}>
                   {
                    isEmpty(this.props.DashboardSaljFilterOption.filter(item=>item.Meta === "DatumFrom" || item.Meta === "DatumTo"))?
                    `${format(new Date(), 'MMMM', { locale: sv })}`
                    :
                    <>
                    {`
                    ${
                        isEmpty(this.props.DashboardSaljFilterOption.filter(item=>item.Meta === "DatumFrom"))?
                        moment(new Date()).format('YYYY-MM-DD'):
                        moment(this.props.DashboardSaljFilterOption.filter(item=>item.Meta === "DatumFrom")[0].Value).format('YYYY-MM-DD')
                    }
                    -
                    ${
                        isEmpty(this.props.DashboardSaljFilterOption.filter(item=>item.Meta === "DatumTo"))?
                        moment(new Date()).format('YYYY-MM-DD'):
                        moment(this.props.DashboardSaljFilterOption.filter(item=>item.Meta === "DatumTo")[0].Value).format('YYYY-MM-DD')
                    }
                    `}
                    </>
                }
                </p>
           </div>
           <div>
           <Grid
           container
           direction="row"
           >
               <Grid item xs={12} style={{ marginTop: this.props.isFrom === 1 ? '-0.5rem' : '0.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {
                      this.state.done===false?
                      <Skeleton variant="rectangular"  height={`135px`} width={'100%'} style={{margin:'auto 10px',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                      :
                  parseInt(this.props.Flags?.DashboardSaljFormat) === 0 ?
                   <div>
                      <span style={{color:"#fff",alignItems:"center", justifyContent:"space-between"}} className="d-flex">
                        {this.formatNumber(this.props.VunnAffarSal)}
                        {
                          parseInt(this.props.authUser.user_canSeeTB1)===1?
                          <p className="d-flex" style={{fontSize:this.props.isFrom === 1 ? 25 : 35}}><span>(</span>{this.formatNumber1(this.props.VunnAffarSal2)}<span>)</span></p>
                          :""
                        }
                    </span>
                  </div>
                  :
                  <div>
                      <span style={{color:"#fff",alignItems:"center", justifyContent:"space-between"}} className="d-flex">
                        <span style={{fontSize:this.props.isFrom === 1 ? 55 : 100}}>
                          {parseInt((this.props.VunnAffarSal/this.props.UtfallSdiagram?.budget)*100)}%
                        </span>
                        {
                          parseInt(this.props.authUser.user_canSeeTB1)===1?
                          <p className="d-flex" style={{fontSize:this.props.isFrom === 1 ? 25 : 35}}>
                            <span>(</span>
                              <span>
                                {parseInt((this.props.VunnAffarSal2/this.props.UtfallSdiagram?.budget)*100)}%
                              </span>
                            <span>)</span>
                          </p>
                          :""
                        }
                    </span>
                  </div>
                }
               </Grid>
               <Grid item xs={12}>
               {
                        this.state.done===false?
                        <Skeleton variant="rectangular"  height={`50px`} width={'100%'} style={{margin:'10px',maxWidth:540,backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                        :
               <Grid
               container
               direction="row"
               justify="space-between"
               alignItems="center"
            //    style={{ marginTop: this.props.isFrom === 1 ? '-1rem' : '0.5rem' }}
               >
               <span style={{color:"#fff"}}>
                   {isEmpty(this.props.SenasteVunnenV)?"":
                   <>
                   <p className="m-0 p-0" style={{fontSize:14}}><IntlMessages id="DashBoard.Deals.Value.Biggest"/></p>
                   <p className="m-0 p-0" style={{
                       fontSize: this.props.isFrom === 1 ? 18 : 25,
                         whiteSpace: "nowrap",
                         width: "300px", 
                         overflow: "hidden",
                         textOverflow: "ellipsis"}}>
                       {this.props.SenasteVunnenV.KundNamn}
                   </p>
                   </>
                   
                   } 
                </span>
               <span style={{ color:"#fff"}}>{isEmpty(this.props.SenasteVunnenV)?"":
               
               parseInt(this.props.Flags?.DashboardSaljFormat) === 0 ?
                <>
                <p className="m-0 p-0" style={{fontSize:14}}><IntlMessages id="DashBoard.Deals.Value.Value"/></p>
                <p className="m-0 p-0 d-flex" style={{fontSize: this.props.isFrom === 1 ? 16 : 20,alignItems:"end"}}>
                    {this.formatNumber1(this.props.SenasteVunnenV.SValue)} {
                       parseInt(this.props.authUser.user_canSeeTB1)===1?
                       <p className="d-flex"><span>(</span>{this.formatNumber1(this.props.SenasteVunnenV.SValue2)}<span>)</span></p>
                       :""
                   }
                </p>
                </> : ''
                }
               </span>
               </Grid>
    }
               </Grid>
           </Grid>
           </div>
            {/**/}
       </div>
       </div>
       </>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(TopList);

